<template>
  <div class="product335-wrap">
    <div class="auto">
      <div class="text">
        <h2>大智慧VIP
          <span style="font-size: 12px;color: #949494;margin-left: 16px;">非投资咨询类软件产品</span>
        </h2>
        <h3>为专业交易用户量身定制</h3>
        <p>大智慧VIP，创新引领投资潮流，智慧点亮财富蓝图，汇聚20年产品优势倾心设计，专为机构客户和投顾专家量身打造，集高端功能、企业预警、策略交易、慧信服务于一体。</p>
        <div class="btn-buy">
          <router-link to="/order/confirm/335/12?s=official" target="_blank"><span>¥68000元/年</span><span>购 买</span></router-link>
          <em @click="showVideo">观看影片</em>
        </div>
      </div>
    </div>
    <div class="mod">
      <div class="auto">
        <h1>
          高端投资者喜欢用的投研工具
        </h1>
        <div class="nav-335">
          <span v-for="(nav, index) in navList1" :key="index" @click="navIndex1 = index;optionIndex1 = 0" :class="{cur: navIndex1 === index}">{{nav}}</span>
        </div>
        <div class="con" v-for="(item, index) in conList1" :key="item.value" v-show="index === navIndex1">
          <div class="con-l">
            <img :src="item.iconSrc" alt="">
            <h2 v-html="item.value"></h2>
            <p v-for="(subItem, i) in item.options" :key="subItem.value" @mouseover="optionIndex1 = i"  :class="{cur: i === optionIndex1}">
              <span>{{subItem.value1}}</span>
              <em>{{subItem.value2}}</em>
            </p>
          </div>
          <div class="con-r">
            <img v-for="(subItem, i) in item.options" :key="subItem.imgSrc" :src="subItem.imgSrc" alt="" v-show="optionIndex1 === i">
          </div>
        </div>
      </div>
    </div>
    <div class="mod mod2">
      <div class="auto">
        <h1>
          企业用户数字化使用场景
        </h1>
        <div class="nav-335">
          <span v-for="(nav, index) in navList2" :key="index" @click="navIndex2 = index;" :class="{cur: navIndex2 === index}">{{nav}}</span>
        </div>
        <div class="con" v-for="(item, index) in conList2" :key="item.value" v-show="index === navIndex2">
          <div class="con-l">
            <img :src="item.imgSrc" alt="">
          </div>
          <div class="con-r">
            <h2>{{item.title}}</h2>
            <p>{{item.summary}}</p>
            <span>咨询电话 021-20219990</span>
          </div>
        </div>
      </div>
    </div>
    <div class="auto footer-335">
      <h3>如果想进一步了解大智慧VIP</h3>
      <p>您可以通过以下方式联系我们,我们将为你推荐适合您需求的产品,或者为您定制解决方案</p>
      <div class="code">
        <img src="../../assets/images/product/335/code335.png" alt="">
        <p>扫码获取一对一服务<br>或致电021-20219999</p>
      </div>
    </div>
    <div class="aside-bar">
      <router-link to="/order/confirm/335/12?s=official" target="_blank" class="item">
        <span></span>
        <p>购买</p>
      </router-link>
      <div class="item" @mouseover="isZx = true" @mouseout="isZx = false">
        <span></span>
        <p>咨询</p>
      </div>
      <a class="item" href="#" @click="download">
        <span></span>
        <p>下载</p>
      </a>
      <img src="../../assets/images/product/335/code335.png" alt="" v-show="isZx">
    </div>
    <!-- <bind-tel :info="info" v-show="isPop" @close="popColse"></bind-tel> -->
    <PartakePop v-show="isPartakePop" @close="popColse" :isHasTel="isHasTel"/>
    <div class="pop-bg" v-show="isPopVideo">
      <span class="close" @click="closeVideo"></span>
      <div class="pop-con">
        <video controls="controls" ref="video">
          <source src="http://1257862591.vod2.myqcloud.com/b143e458vodtranscq1257862591/5ff0de453270835009854929051/v.f40.mp4"  type="video/mp4"/>
        </video>
      </div>
    </div>
  </div>
</template>

<script>
// import BindTel from './BindTel.vue'
import PartakePop from './PartakePop.vue'
export default {
  components: {
    // BindTel,
    PartakePop
  },
  data () {
    return {
      token: "",
      info: {
        isWait: true,
        isBind: true,
        bindUrl: '',
      },
      isPop: false,
      navIndex1: 0,
      optionIndex1: 0,
      navList1: ['投资因子库', '全链预警', 'SCRM', 'AI GPT', '特色功能'],
      conList1: [
        {
          value: '投资因子库<br>个性化策略1分钟生成',
          iconSrc: require('../../assets/images/product/335/icon1.png'),
          options: [
            {
              value1: '个性化策略制定，简单上手',
              value2: '无需编程基础，简单拖拽，实现策略编辑',
              imgSrc: require('../../assets/images/product/335/1-1.jpg'),
            },
            {
              value1: '回测速度，秒级响应',
              value2: '回测5年以上的数据，仅几秒',
              imgSrc: require('../../assets/images/product/335/1-2.jpg'),
            },
            {
              value1: '海量因子库，广泛的场景应用',
              value2: '用因子池，筛选或回测自选股，寻找机会',
              imgSrc: require('../../assets/images/product/335/1-3.jpg'),
            },
            {
              value1: '多因子策略，自动寻找优质参数',
              value2: '算法自动优化，生成最优方案',
              imgSrc: require('../../assets/images/product/335/1-4.jpg'),
            }
          ]
        },
        {
          value: '知风险，懂舆情',
          iconSrc: require('../../assets/images/product/335/icon3.png'),
          options: [
            {
              value1: '全市场多维权威研究数据',
              value2: '各类数据像行情一样的每1小时更新',
              imgSrc: require('../../assets/images/product/335/3-1.jpg'),
            },
            {
              value1: '监控上市公司‘经营’情况',
              value2: '所在‘行业’，自身‘经营、创新、价值、预警’，360度监控',
              imgSrc: require('../../assets/images/product/335/3-2.jpg'),
            },
            {
              value1: '行业研究员人工搭建预警模型',
              value2: '为每个上市公司专属搭建',
              imgSrc: require('../../assets/images/product/335/3-3.jpg'),
            },
            {
              value1: '人机双结合，双线预警机制',
              value2: '系统自动提醒，通过研究员审核后发出预警',
              imgSrc: require('../../assets/images/product/335/3-4.jpg'),
            }
          ]
        },
        {
          value: '高效沟通，智能服务',
          iconSrc: require('../../assets/images/product/335/icon4.png'),
          options: [
            {
              value1: '内容创作与智能分发平台',
              value2: '优质内容流量扶持',
              imgSrc: require('../../assets/images/product/335/4-1.jpg'),
            },
            {
              value1: '监路演及直播',
              value2: '专注金融细分领域，每场都是干货',
              imgSrc: require('../../assets/images/product/335/4-2.jpg'),
            },
            {
              value1: '“慧信”沟通',
              value2: '丰富的OA应用，更贴合投资者',
              imgSrc: require('../../assets/images/product/335/4-3.jpg'),
            }
          ]
        },
        {
          value: '编写指标公式<br>解答财经知识，不在话下',
          iconSrc: require('../../assets/images/product/335/icon5.png'),
          options: [
            {
              value1: '编写选股指标公式',
              value2: '复杂公式，交给“小慧”完成',
              imgSrc: require('../../assets/images/product/335/5-1.jpg'),
            },
            {
              value1: '解答财经专有名词',
              value2: '无需死记硬背，“小慧”为您服务',
              imgSrc: require('../../assets/images/product/335/5-1.jpg'),
            },
            {
              value1: '提供在线翻译',
              value2: '阅读英语资讯，也游刃有余',
              imgSrc: require('../../assets/images/product/335/5-1.jpg'),
            }
          ]
        },
        {
          value: '特色功能',
          iconSrc: require('../../assets/images/product/335/icon9.png'),
          options: [
            {
              value1: '多维分析，资金分析体系',
              value2: 'AI系列指标，热点监控，多方位分析资金动向',
              imgSrc: require('../../assets/images/product/335/11-1.jpg'),
            },
            {
              value1: '大数据挖掘',
              value2: '多角度挖掘机构动向，通过数据实现价值发现',
              imgSrc: require('../../assets/images/product/335/11-2.jpg'),
            },
          ]
        }
      ],
      navIndex2: 0,
      navList2: ['券商', '投顾', '基金', '私募', '上市公司'],
      conList2: [
        {
          title: '一站式解决方案 助力行业升级',
          summary: '助力券商打造一站式投资者服务，解决从获客到用户分层管理，通过SCRM系统，为客户提供定制服务。',
          imgSrc: require('../../assets/images/product/335/6-1.jpg'),
        },
        {
          title: '用户服务解决方案',
          summary: '通过SCRM系统中画像功能，结合AI GPT智能机器人，将客户沟通及策略分析等功能，集成在一个平台上，全面实现，获客、沟通、资讯获取、市场分析、报告撰写等流程的融合，数据的穿透，彻底释放投顾服务业务的效能！',
          imgSrc: require('../../assets/images/product/335/7-1.jpg'),
        },
        {
          title: '基金解决方案',
          summary: '研究院服务将为机构用户提供各类行业报告，通过与研究员在线互动，及时了解最新的行业动态及公司动态，搭配使用“全链预警”功能，将公司所在链路上的所有信息进行全面监控。',
          imgSrc: require('../../assets/images/product/335/8-1.jpg'),
        },
        {
          title: '专属调研与量化投研',
          summary: '除了有各行业研究报告外、研究院还可定制专属调研报告，为机构提供个性化的调研分析及策略分析。因子投研功能与策略交易功能，可进行策略创建及量化分析。',
          imgSrc: require('../../assets/images/product/335/9-1.jpg'),
        },
        {
          title: '维护投资者关系与企业舆情',
          summary: '将公司舆情与研报完全融合，结合舆情通、研究院及AI GPT智能机器人，解决内容撰写、行业研究以及公司舆情监控一站式功能，提升工作效能！',
          imgSrc: require('../../assets/images/product/335/10-1.jpg'),
        },
      ],
      // 试运行数据
      isPartakePop: false,
      isHasTel: false,
      isZx: false, // 咨询图片
      isPopVideo: false, // video弹框是否显示
    }
  },
  filters:{
    formateBrText:function(v){
      return v.replace('<br/>','')
    }
  },
  methods: {
    goUrl (key) {
      this.isPop = true
      this.$get('user/checkMobile').then(res =>{
        if(res.code === 0) {
          this.isPop = false
          let routerDate;
          if (this.token) {
            routerDate = this.$router.resolve({name: 'ClientProduct', query: {token: this.token, pid: key}})
          } else {
            routerDate = this.$router.resolve({name: 'OrderConfirm', params:{productId: key,month:12}})
          }
          let href = routerDate.href + "?s=official"
          window.open(href, "_blank")
        } else if(res.code === 107) {
          this.info.isWait = false
          this.info.isBind = false
          this.info.bindUrl = res.msg
        } else {
            this.$global.alert(res.msg);
          }
      }).catch(err => {
        this.$global.alertError();
      });
    },
    popColse (val) {
      // this.isPop = val
      this.isPartakePop = val
    },
    goParkate () {
      this.$router.push("/order/confirm/335/12");
    },
    // 显示video
    showVideo () {
      this.isPopVideo = true
      document.querySelector("#app").classList.add("ov")
      this.$refs.video.play()
    },
    // 隐藏video
    closeVideo () {
      this.isPopVideo = false
      document.querySelector("#app").classList.remove("ov")
      this.$refs.video.pause()
    },
    download() {
      this.$get("/product/query?id=335")
        .then(response => {
          if (response.code === 0) {
            window.location.href = response.data.downloadUrl;
          } else {
            this.$global.alert(response.msg);
          }
        })
        .catch(err => {
          this.$global.alertError();
        });
    }
  }
}
</script>
<style lang="scss">
.ov{
  overflow: hidden;
  height: 100vh;
}
</style>
<style lang="scss" scoped>
div, p, span{
  box-sizing: border-box;
}
.product335-wrap{
  background: url(~@/assets/images/product/335/bg-new.jpg) no-repeat center 0;
}
.auto{
  width: 1200px;
  margin: 0 auto;
  position: relative;
}
.text{
  color: #fff;
  padding-top: 100px;
  margin-left: 680px;
  width: 500px;
  height: 490px;
  h2{
    font-size: 34px;
    em{
      font-size: 20px;
    }
  }
  h3{
    font-size: 22px;
    margin: 12px 0 15px;
  }
  p{
    font-size: 14px;
    line-height: 22px;
  }
}
.btn-buy{
  cursor: pointer;
  margin-top: 20px;
  font-size: 0;
  a{
    color: #fff;
    background: #4D88FC;
    display: inline-block;
    height: 40px;
    line-height: 40px;
    padding: 0px 25px 0 15px;
    margin-right: 10px;
    font-size: 0px;
    span{
      font-size: 16px;
      &:nth-child(1) {
        margin-right: 20px;
      }
    }
  }
  em{
    border: 2px solid #4D88FC;
    color: #4D88FC;
    font-size: 16px;
    display: inline-block;
    height: 40px;
    line-height: 36px;
    box-sizing: border-box;
    padding: 0 17px;
    &:after{
      content: '';
      display: inline-block;
      width: 0;
      height: 0;
      border-top: 6px solid transparent;
      border-left: 10px solid #4D88FC;
      border-bottom: 6px solid transparent;
      vertical-align: middle;
      margin-left: 10px;
    }
  }
}
.mod{
  padding: 55px 0;
  background: #fff;
  h1{
    color: #3D3D3D;
    font-size: 34px;
    text-align: center;
    font-weight: bold;
  }
  .nav-335{
    color: #3D3D3D;
    font-size: 16px;
    margin: 23px 0 56px;
    text-align: center;
    span{
      padding: 8px 20px;
      margin-right: 10px;
      border-radius: 20px;
      cursor: pointer;
      &.cur{
        background: #3D3D3D;
        color: #fff;
      }
    }
  }
  .con{
    margin-left: 50px;
    height: 408px;
    .con-l{
      float: left;
      width: 320px;
      img{
        width: 28px;
      }
      p{
        color: #A1A4A8;
        margin-bottom: 20px;
        font-size: 14px;
        cursor: pointer;
        position: relative;
        padding-left: 12px;
        &.cur{
          color: #416EFB;
          &:before{
            content: '';
            display: inline-block;
            width: 0px;
            height: 0px;
            border-left: 8px solid #4D88FC;
            border-top: 5px solid transparent;
            border-bottom: 5px solid transparent;
            position: absolute;
            left: 0px;
            top: 5px;
          }
          em{
            color: #3D3D3D;
          }
          span{
            font-weight: bold;
          }
        }
        em{
          font-size: 12px;
          display: block;
          margin-top: 5px;
        }
      }
    }
    .con-r{
      margin-left: 350px;
      img{
        width: 700px;
      }
    }
    h2{
      font-size: 20px;
      margin-bottom: 15px;
      margin-top: 5px;
      font-weight: 900;
      color: #3D3D3D;
    }

  }
}
.mod2{
  background: #F4F4F4;
  .con{
    height: 353px;
    .con-l{
      width: 500px;
      img{
        width: 500px;
        display: block;
        border-radius: 20px 0 0 20px;
      }
    }
    .con-r{
      margin-left: 500px;
      border-radius: 0px 20px 20px 0px;
      background: #3D3D3D;
      width: 560px;
      height: 100%;
      padding: 70px 0 0 45px;
      h2{
        color: #FCFCFC;
        font-size: 20px;
      }
      p{
        color: #F4F4F4;
        font-size: 16px;
        width: 400px;
        line-height: 24px;
      }
      span{
        font-size: 14px;
        color: #fff;
        background: #4D88FC;
        height: 36px;
        line-height: 36px;
        padding: 0 15px;
        display: inline-block;
      }
    }
  }

}
.footer-335{
  padding: 45px 0 35px;
  background: url(~@/assets/images/product/335/bg2.png) no-repeat right bottom;
  h3{
    color: #416EFB;
    font-size: 26px;
  }
  p{
    font-size: 16px;
    color: #3D3D3D;
    margin: 10px 0 10px;
  }
  .code{
    height: 136px;
    img{
      float: left;
      width: 136px;
    }
    p{
      margin-left: 150px;
      font-size: 14px;
      color: #3D3D3D;
      line-height: 26px;
      padding-top: 35px;
    }
  }
}
.aside-bar{
  border-radius: 35px;
  background: #FFFFFF;
  box-shadow: 0px 2px 10px rgba($color: #000000, $alpha: 0.1);
  font-size: 12px;
  color: #3D3D3D;
  width: 64px;
  position: fixed;
  right: 20px;
  top: 30%;
  text-align: center;
  padding: 20px 0;
  span{
    display: block;
    width: 48px;
    height: 48px;
    background: url(~@/assets/images/product/335/icon6-1.png) no-repeat;
    background-size: 100% auto;
    margin: 0 auto 3px;
  }
  >img{
    display: block;
    width: 120px;
    position: absolute;
    right: 68px;
    top: 90px;
  }
  .item{
    display: block;
    color: #3D3D3D;
    cursor: pointer;

    &+.item{
      margin-top: 15px;
    }
    &:nth-child(2) {
      span{
        background: url(~@/assets/images/product/335/icon7-1.png) no-repeat;
        background-size: 100% auto;
      }
    }
    &:nth-child(3) {
      span{
        background: url(~@/assets/images/product/335/icon8-1.png) no-repeat;
        background-size: 100% auto;
      }
    }
    &:hover{
      span{
        background: url(~@/assets/images/product/335/icon6-2.png) no-repeat;
        background-size: 100% auto;
      }
      &:nth-child(2) {
      span{
        background: url(~@/assets/images/product/335/icon7-2.png) no-repeat;
        background-size: 100% auto;
      }
    }
    &:nth-child(3) {
      span{
        background: url(~@/assets/images/product/335/icon8-2.png) no-repeat;
        background-size: 100% auto;
      }
    }
    }
  }
}
.pop-bg{
  position: fixed;
  left: 0px;
  right: 0px;
  top: 0px;
  bottom: 0px;
  z-index: 10;
  background: #fff;
  .close{
    position: fixed;
    top: 30px;
    left: 50px;
    border-radius: 50%;
    border: 1px solid #333;
    display: block;
    width: 60px;
    height: 60px;
    cursor: pointer;
    &:before{
      content: '';
      display: block;
      width: 40px;
      height: 1px;
      -webkit-transform: rotate(45deg);
          -ms-transform: rotate(45deg);
              transform: rotate(45deg);
      background: #333;
      position: absolute;
      top: 28px;
      left: 8px;
    }
    &:after{
      content: '';
      display: block;
      width: 40px;
      height: 1px;
      -webkit-transform: rotate(-45deg);
          -ms-transform: rotate(-45deg);
              transform: rotate(-45deg);
      background: #333;
      position: absolute;
      top: 28px;
      left: 8px;
    }
  }
  .pop-con{
    width: 80%;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    video{
      width: 100%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/product/Product335.vue